export default {

    props: {
        'userId': {
            type: Number,
            default: 0
        }
    },

    data() {
        return {
            id: 0,
            profile_photo: '',
            name: '',
            email: ''
        }
    },

    created() {
        this.fetchUserData();
    },

    computed: {
        initial() {
            if (this.name) {
                return this.name[0].toUpperCase();
            } else {
                return '?';
            }
        },

        firstName() {
            return this.name.split(' ')[0];
        },

        lastName() {
            return this.name.split(' ')[1];
        }
    },

    methods: {
        fetchUserData() {
            let id = this.userId;
            let userData = false;
            if (this.userdId !== 0) {
                userData = _.find(window.AR.data.users, user => (user.id ===  id));
                if (userData) {
                    this.id = userData.id;
                    this.profile_photo = userData.profile_photo;
                    this.name = userData.name;
                    this.email = userData.email;
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/userMixin.js